import { render } from "./CNGNav.vue?vue&type=template&id=4fffaac8&scoped=true"
import script from "./CNGNav.vue?vue&type=script&lang=js"
export * from "./CNGNav.vue?vue&type=script&lang=js"

import "./CNGNav.vue?vue&type=style&index=0&id=4fffaac8&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fffaac8"]])

export default __exports__